const TheContainer = () => import('@/containers/TheContainer')
const LogsTransactions = () => import('./pages/LogsTransactions.vue')

const transactionLogsRoutes = [
  {
    path: 'transational',
    component: TheContainer,
    children: [
      {
        path: 'api/logs',
        name: 'logs-trasactions',
        component: LogsTransactions,
        meta: { requiresAuth: true },
      },
    ],
  },
]

export default transactionLogsRoutes
